var React = require('react');

function Inventory (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 10313","d":"M108.2,21.074h-19.5a.627.627,0,0,0-.626.626V41.2a.627.627,0,0,0,.626.626h19.5a.627.627,0,0,0,.626-.626V21.7A.627.627,0,0,0,108.2,21.074Zm-11.63,1.253h3.758v5.606l-1.6-.8a.625.625,0,0,0-.56,0l-1.6.8Zm11,18.25H89.32V22.327h5.993v6.619a.627.627,0,0,0,.907.56l2.225-1.113,2.225,1.113a.626.626,0,0,0,.906-.56V22.327h5.993Z","transform":"translate(-88.068 -21.074)","fill":"#e03116"}));
}

Inventory.defaultProps = {"data-name":"Group 4471","width":"20.755","height":"20.755","viewBox":"0 0 20.755 20.755"};

module.exports = Inventory;

Inventory.default = Inventory;
